<template>
  <b-modal id="modal-import-result" v-model="visible" size="md" :title="title" centered>
    <div class="text-center mb-4">
      <div class="text-center">
        <p style="text-align: center">
          <strong>Số bản ghi thành công:</strong>
          {{ importResultData?.countSuccess || 0 }}
        </p>
        <p style="text-align: center">
          <strong>Số bản ghi thất bại:</strong>
          {{ importResultData?.countError || 0 }}
        </p>
      </div>
      <button
        v-if="importResultData.countError"
        style="font-weight: 400"
        class="btn btn-outline-danger mt-2"
        @click="downloadErrorFile(importResultData.errors)"
      >
        Tải bản ghi thất bại
      </button>
    </div>

    <template #modal-footer>
      <button class="btn btn-primary" @click="visible = false">OK</button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />
  </b-modal>
</template>
<script>
import { MerchantService } from '@/services/merchant.service'
import { showMessErrorResponse } from '@/config/utils'
import fileDownload from 'js-file-download'
export default {
  data () {
    return {
      visible: false,
      title: 'Nhập file thành công',
      importResultData: {},
      showLoading: false
    }
  },
  methods: {
    closeModal () {
      this.visible = false
    },
    openModal (payload) {
      this.visible = true
      this.importResultData = { ...payload }
    },
    async downloadErrorFile (fileError) {
      try {
        this.showLoading = true
        const res = await MerchantService.downloadErrorFileMcAgent(fileError)
        fileDownload(res.data, 'template_import_lead_for_vcb_ho_faild.xlsx')
      } catch (error) {
        showMessErrorResponse(this, error)
      } finally {
        this.showLoading = false
        this.visible = false
      }
    }
  }
}
</script>
